import { flexRender, Table as TanstackTable } from "@tanstack/react-table";
import { TableHeader, TableRow } from "./TableComponents";
import { resolveColumnWidthStyle } from "./columnWidth";
import React from "react";

export function TableHeaderSkeleton<T>({ table }: { table: TanstackTable<T> }) {
  return (
    <>
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id} className="border-none">
          {headerGroup.headers.map((header) => (
            <TableHeader
              key={header.id}
              className={`bg-base-100 text-base-content/70 border-none text-sm font-medium ${header.column.columnDef.meta?.className}`}
              style={resolveColumnWidthStyle(header.column.columnDef)}
            >
              {flexRender(header.column.columnDef.header, header.getContext())}
            </TableHeader>
          ))}
        </TableRow>
      ))}
    </>
  );
}
